// `first_sync_completed` (de companies[] en /users/user_info/) tiene 4 estados:
//   false        → sin link SII activo (no conectado)
//   null         → conectado, primer sync en progreso
//   'SyncError'  → conectado pero trabado (>1 día)
//   true         → primer sync completo
// Mostramos el robot "obteniendo datos del SII" mientras NO esté completo.
export function isSiiSyncing(firstSyncCompleted) {
    return firstSyncCompleted !== true;
}

// Resuelve el estado de sync desde el payload del usuario (/users/user_info/).
// OJO: el campo vive en `companies[].first_sync_completed`, NO en
// `account_link` (que puede no estar presente). Leer el path equivocado fue un
// bug que dejaba el robot sin aparecer — el test de regresión lo cubre.
export function isUserSiiSyncing(user) {
    const company = user && user.companies && user.companies[0];
    if (!company) return false;
    return isSiiSyncing(company.first_sync_completed);
}
